export default __webpack_public_path__ + "static/media/IN-webinar certificate.da928333.png";